// extracted by mini-css-extract-plugin
export default {"innerTopBox":"TipBoxTop_innerTopBox__hnIww","unavailable":"TipBoxTop_unavailable__dSYTj","message":"TipBoxTop_message__0MvTW","unlocked":"TipBoxTop_unlocked__WkRhT"};